import { ErrorBoundaryFallbackProps } from "@suspensive/react";
import { GenericErrorPage } from "shared/components/empty/GenericErrorPage";
import Page from "shared/components/layout/Page";
import PageContainer from "shared/components/layout/PageContainer";

export const AppRootErrorPage: React.FC<ErrorBoundaryFallbackProps> = (
  props,
) => (
  <Page>
    <PageContainer>
      <GenericErrorPage showSignOut={true} {...props} />
    </PageContainer>
  </Page>
);
